import { NgModule } from '@angular/core';
import { SharedModule } from '../../shared/shared.module';
import { MedicalAdviceListComponent } from './list/medical-advice.component';
import { MedicalAdviceRoutingModule } from './medical-advice.routing';

@NgModule({
  declarations: [MedicalAdviceListComponent],
  imports: [SharedModule, MedicalAdviceRoutingModule],
})
export class MedicalAdviceModule {}
